var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "theme-vdoing-content"
  }, [_c('div', {
    staticClass: "column-wrapper"
  }, [_vm.pageData.imgUrl ? _c('img', {
    attrs: {
      "src": _vm.$withBase(_vm.pageData.imgUrl)
    }
  }) : _vm._e(), _vm._v(" "), _c('dl', {
    staticClass: "column-info"
  }, [_c('dt', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.pageData.title))]), _vm._v(" "), _c('dd', {
    staticClass: "description",
    domProps: {
      "innerHTML": _vm._s(_vm.pageData.description)
    }
  })])]), _vm._v(" "), _vm.isStructuring ? _c('div', {
    staticClass: "catalogue-wrapper"
  }, [_c('div', {
    staticClass: "catalogue-title"
  }, [_vm._v("目录")]), _vm._v(" "), _c('div', {
    staticClass: "catalogue-content"
  }, [_vm._l(_vm.getCatalogueList(), function (item, index) {
    return [_vm.type(item) === 'array' ? _c('dl', {
      key: index,
      staticClass: "inline"
    }, [_c('dt', [_c('router-link', {
      attrs: {
        "to": item[2]
      }
    }, [_vm._v(_vm._s(`${index + 1}. ${item[1]}`) + "\n              "), item[3] ? _c('span', {
      staticClass: "title-tag"
    }, [_vm._v("\n                " + _vm._s(item[3]) + "\n              ")]) : _vm._e()])], 1)]) : _vm.type(item) === 'object' ? _c('dl', {
      key: index
    }, [_c('dt', {
      attrs: {
        "id": _vm.anchorText = item.title
      }
    }, [_c('a', {
      staticClass: "header-anchor",
      attrs: {
        "href": `#${_vm.anchorText}`
      }
    }, [_vm._v("#")]), _vm._v("\n            " + _vm._s(`${index + 1}. ${item.title}`) + "\n          ")]), _vm._v(" "), _c('dd', [_vm._l(item.children, function (c, i) {
      return [_vm.type(c) === 'array' ? [_c('router-link', {
        key: i,
        attrs: {
          "to": c[2]
        }
      }, [_vm._v(_vm._s(`${index + 1}-${i + 1}. ${c[1]}`) + "\n                  "), c[3] ? _c('span', {
        staticClass: "title-tag"
      }, [_vm._v("\n                    " + _vm._s(c[3]) + "\n                  ")]) : _vm._e()])] : _vm.type(c) === 'object' ? _c('div', {
        key: i,
        staticClass: "sub-cat-wrap"
      }, [_c('div', {
        staticClass: "sub-title",
        attrs: {
          "id": _vm.anchorText = c.title
        }
      }, [_c('a', {
        staticClass: "header-anchor",
        attrs: {
          "href": `#${_vm.anchorText}`
        }
      }, [_vm._v("#")]), _vm._v("\n                  " + _vm._s(`${index + 1}-${i + 1}. ${c.title}`) + "\n                ")]), _vm._v(" "), _vm._l(c.children, function (cc, ii) {
        return _c('router-link', {
          key: `${index + 1}-${i + 1}-${ii + 1}`,
          attrs: {
            "to": cc[2]
          }
        }, [_vm._v("\n                  " + _vm._s(`${index + 1}-${i + 1}-${ii + 1}. ${cc[1]}`) + "\n                  "), cc[3] ? _c('span', {
          staticClass: "title-tag"
        }, [_vm._v("\n                    " + _vm._s(cc[3]) + "\n                  ")]) : _vm._e()]);
      })], 2) : _vm._e()];
    })], 2)]) : _vm._e()];
  })], 2)]) : _vm._e()]);
};
var staticRenderFns = [];
export { render, staticRenderFns };